import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { formatVersion, sections, toHashLabel } from '../../helpers';
import { AboutSidebarProps } from '../../types';

const groupedSections = sections.reduce(
  (acc, section) => {
    if (!acc[section.group]) acc[section.group] = [];
    acc[section.group].push(section);
    return acc;
  },
  {} as Record<string, typeof sections>,
);

const AboutSidebar: React.FC<AboutSidebarProps & { collapsed?: boolean }> = ({
  versionsArray,
  onClick,
  collapsed = false,
}) => {
  const [searchParams] = useSearchParams();
  const versionParam = searchParams.get('version');
  const sectionParam = searchParams.get('section');

  const isActiveSection = (section: string) => sectionParam === section;
  const isActiveVersion = (version: string) => versionParam === version;

  return (
    <div className={`w-full ${collapsed ? 'max-w-[64px]' : 'max-w-[320px]'} lg:mb-6 transition-all duration-300`}>
      <div>
        <div className="p-3">
          {Object.entries(groupedSections).map(([group, items]) => (
            <div key={group} className={group !== 'Statistics' ? 'mt-3' : ''}>
              {!collapsed && (
                <div className="uppercase font-bold text-lg mb-2 tracking-wider text-blue">{group}</div>
              )}
              <div className="flex flex-col gap-1">
                {items.map(({ label, value }) => (
                  <Link
                    key={value}
                    to={`?section=${value}`}
                    className={`sidebar-link ${isActiveSection(value) ? 'active' : ''}`}
                    onClick={onClick}
                  >
                    {!collapsed && label}
                  </Link>
                ))}
              </div>
            </div>
          ))}

          <div className="mt-4">
            {!collapsed && (
              <div className="uppercase font-bold text-lg mb-2 tracking-wider text-blue">Version History</div>
            )}
            <div className="flex flex-col gap-1">
              {versionsArray.map(v => {
                const versionLabel = formatVersion(v.version);
                const versionParamValue = toHashLabel(v.version);
                return (
                  <Link
                    key={v.version}
                    to={`?version=${versionParamValue}`}
                    className={`sidebar-link  ${
                      isActiveVersion(versionParamValue) ? 'active' : ''
                    }`}
                    onClick={onClick}
                  >
                    {!collapsed && `Version ${versionLabel}`}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSidebar;